import React, { useEffect, useRef } from "react"

export function FilterItem (props: {
    isSelected: boolean;
    name: React.ReactNode;
    isRecent?: boolean;
}
) {
    const chipRef = useRef<HTMLDivElement>(null);
    const prevSelectedRef = useRef(props.isSelected);

    useEffect(() => {
        // 상태가 변경되었을 때만 애니메이션 트리거
        if (props.isSelected && !prevSelectedRef.current && chipRef.current) {
            chipRef.current.classList.add('animate-selected');
            // 애니메이션 완료 후 클래스 제거
            setTimeout(() => {
                chipRef.current?.classList.remove('animate-selected');
            }, 200);
        }
        prevSelectedRef.current = props.isSelected;
    }, [props.isSelected]);

    const getClassName = () => {
        if (!props.isSelected) return "defaultChip";
        if (props.isRecent) return "selectedChipRecent";
        return "selectedChip";
    };

    return (
        <div ref={chipRef} className={getClassName()}>
            <span className="chip-content">{props.name}</span>
          </div>
    )
}
